/**
 * Zahlbetrag einer Eingangsrechnung: Rechnungsbetrag minus Skonto, wenn es gezogen wird.
 * Der Rechnungsbetrag selbst bleibt wie auf dem Beleg. Genutzt von der Vorschau (Zahlbetrag-Zeile)
 * und vom SEPA-Export, damit beide denselben Betrag zeigen bzw. überweisen.
 */

export type IncomingPayableInput = {
  /** Rechnungsbetrag (payable_amount, sonst gross_amount). */
  baseAmount: number;
  skontoAmount: number | string | null | undefined;
  /** YYYY-MM-DD; ohne Frist wird Skonto nur bei skontoTaken abgezogen. */
  skontoDueDate: string | null | undefined;
  skontoTaken: boolean | null | undefined;
  /** Zahlungs- bzw. Ausführungsdatum, YYYY-MM-DD. */
  paymentDate: string;
};

export type IncomingPayableAmount = {
  amount: number;
  /** Abgezogener Skontobetrag, 0 wenn ohne Skonto gezahlt wird. */
  skontoApplied: number;
  /** Skonto ist hinterlegt (unabhängig davon, ob es abgezogen wird). */
  hasSkonto: boolean;
  skontoExpired: boolean;
};

const roundCents = (value: number) => Math.round(value * 100) / 100;

export function incomingPayableAmount(input: IncomingPayableInput): IncomingPayableAmount {
  const base = Number.isFinite(input.baseAmount) ? input.baseAmount : 0;
  const skonto = Number(input.skontoAmount);
  const hasSkonto = skonto > 0 && base > 0;
  const dueDate = /^\d{4}-\d{2}-\d{2}/.test(String(input.skontoDueDate ?? ''))
    ? String(input.skontoDueDate).slice(0, 10)
    : null;
  const skontoExpired = hasSkonto && dueDate != null && input.paymentDate.slice(0, 10) > dueDate;
  const apply = hasSkonto && (Boolean(input.skontoTaken) || (dueDate != null && !skontoExpired));
  const skontoApplied = apply ? roundCents(Math.min(skonto, base)) : 0;
  return {
    amount: roundCents(base - skontoApplied),
    skontoApplied,
    hasSkonto,
    skontoExpired,
  };
}
